// @ts-nocheck

(function () {
    const CART_SECTIONS = ['mm-cart-drawer', 'header'];
    const CART_SECTIONS_STR = CART_SECTIONS.join(',');
  
    function getCartDrawer() {
      return document.querySelector('mm-cart-drawer');
    }
  
    function injectSections(body) {
      try {
        if (typeof body === 'string') {
          const data = JSON.parse(body);
          if (!data.sections) {
            data.sections = CART_SECTIONS_STR;
          } else if (typeof data.sections === 'string') {
            const existing = data.sections.split(',');
            CART_SECTIONS.forEach(s => { if (!existing.includes(s)) existing.push(s); });
            data.sections = existing.join(',');
          } else if (Array.isArray(data.sections)) {
            CART_SECTIONS.forEach(s => { if (!data.sections.includes(s)) data.sections.push(s); });
          }
          return JSON.stringify(data);
        }
        if (body instanceof FormData) {
          if (!body.has('sections')) body.append('sections', CART_SECTIONS_STR);
          return body;
        }
        if (body instanceof URLSearchParams) {
          if (!body.has('sections')) body.append('sections', CART_SECTIONS_STR);
          return body;
        }
      } catch (_) { /* can't parse — pass through */ }
      return body;
    }
  
    async function onCartAddSuccess(parsedResponse) {
      try {
        const cartJson = await (
          await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
        ).json();
  
        if (parsedResponse.sections) {
          cartJson.sections = parsedResponse.sections;
        }
  
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-intercept',
          cart: cartJson,
        });
  
        getCartDrawer()?.show();
      } catch (err) {
        console.error('[mm-cart-intercept] Error updating cart drawer:', err);
      }
    }
  
    const originalFetch = window.fetch;
  
    window.fetch = async function (...args) {
      const [resource, config] = args;
      const url = typeof resource === 'string' ? resource : resource?.url;
  
      if (url && url.includes('/cart/add')) {
        if (config?.body) config.body = injectSections(config.body);
  
        const response = await originalFetch.apply(this, args);
  
        if (response.ok) {
          const clone = response.clone();
          clone.json().then(onCartAddSuccess).catch(() => {});
        }
  
        return response;
      }
  
      return originalFetch.apply(this, args);
    };
  })();
  